module.exports = __webpack_public_path__ + "static/media/AMEX.02b583b8.svg";